const initVideoStories = () => {
  const section = document.querySelector(".VideoStories");

  if (section.dataset.scrollActivation !== "true") return;

  const items = section.querySelectorAll(".VideoStories--video");
  const videos = Array.from(items).map((item) => item.querySelector("video"));
  const step = 1 / items.length;

  let currentIndex = -1;
  let scrollIndex = -1;
  let hoveredIndex = -1;
  let ticking = false;
  let active = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const rect = section.getBoundingClientRect();
      // start: "bottom bottom" (section bottom hits viewport bottom) -> end: "top top" (section top hits viewport top)
      const start = window.innerHeight - rect.height;
      const end = 0;
      let ratio = (start - rect.top) / (start - end);
      if (ratio < 0) ratio = 0;
      if (ratio > 1) ratio = 1;
      scrollIndex = Math.min(Math.floor(ratio / step), items.length - 1);
      if (hoveredIndex === -1 && scrollIndex !== currentIndex) SetActive(scrollIndex);
      ticking = false;
    });
  }

  function SetActive(index) {
    currentIndex = index;
    items.forEach((item, i) => {
      const video = videos[i];
      if (i === index) {
        item.classList.add("Active");
        if (video) video.play();
      } else {
        item.classList.remove("Active");
        if (video) video.pause();
      }
    });
  }

  function ShowAll() {
    items.forEach((item, i) => {
      item.classList.add("Active");
      if (videos[i]) videos[i].play();
    });
  }

  function updateActivation() {
    const shouldBeActive = window.innerWidth > 768;
    if (shouldBeActive === active) return;
    active = shouldBeActive;
    if (active) {
      window.addEventListener("scroll", onScroll);
      onScroll();
    } else {
      window.removeEventListener("scroll", onScroll);
      currentIndex = -1;
      ShowAll();
    }
  }

  items.forEach((item, i) => {
    item.addEventListener("mouseenter", () => {
      if (!active) return;
      hoveredIndex = i;
      SetActive(i);
    });
    item.addEventListener("mouseleave", () => {
      if (!active) return;
      hoveredIndex = -1;
      SetActive(scrollIndex);
    });
  });

  updateActivation();
  window.addEventListener("resize", updateActivation);
};

initVideoStories();
